/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-restricted-globals */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { store } from 'store/ConfigureStore';
import { Provider } from 'react-redux';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { EVThemeProvider } from '@eagleview/ev-comp-library';
import { LAUNCH_DARKLY_CLIENT_ID } from 'constants/AppConstants';
import Loader from 'commonComponents/Loader';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as pushNotification from './pushNotification';
import './i18n';

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: LAUNCH_DARKLY_CLIENT_ID,
  });
  /**
   * mounts App compoennt to DOM element with id='root'
   */
  ReactDOM.render(
    <Suspense
      fallback={(
        <Loader />
      )}
    >
      <Provider store={store}>
        <EVThemeProvider classPrefix="vp">
          <LDProvider>
            <App />
          </LDProvider>
        </EVThemeProvider>
      </Provider>
    </Suspense>,
    document.getElementById('root'),
  );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

pushNotification.validateAndRegister();
serviceWorkerRegistration.register();
